const getDefaultState = () => {
    return {userCompanies: []}
}

const state = getDefaultState()

const getters = {
    getUserCompanies: state => {
        if (!state.userCompanies) {
            return [];
        }
        return state.userCompanies
    }
};

const mutations = {
    resetCompaniesState: (state) => Object.assign(state, getDefaultState()),
    setUserCompanies: (state, companies) => state.userCompanies = companies
};

const actions = {
    async fetchUserCompanies ({commit, getters}){
        let companies = await axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/company/user',
            cancelToken: window.AuthorizationCancelSource.token,
        });

        commit('setUserCompanies', companies.data);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}
